import { render, staticRenderFns } from "./BA_Loading.vue?vue&type=template&id=18486079&"
import script from "./BA_Loading.vue?vue&type=script&lang=js&"
export * from "./BA_Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports